module.exports = __webpack_public_path__ + "static/media/descargar-negro.e82652a8.svg";